$(document).ready(function(){
	
  
	var myslider;
	
	myslider = $('.googleReview-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 7000,
    centerMode: false,
    variableWidth: false,
    prevArrow: '<button type="button" class="slick-prev">prev</button>',
    nextArrow: '<button type="button" class="slick-next">next</button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
  
  $('.googleReview-slider .slick-list').show();
  
  $('.googleReview-slider').on("swipe", function(event, slick, direction) {
    myslider.slick('slickSetOption', {
      'autoplay': false
    }, true);
  });

  $(".slick-prev, .slick-next, .slick-dots button").on("click", function() {
    myslider.slick('slickSetOption', {
      'autoplay': false
    }, true);
  });
  
    
  myslider.on('init', function (event, slick) {
    
  });

});